import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Badge,
} from "reactstrap"
import { connect } from "react-redux"
import Select from "react-select"
import { setBreadcrumbItems } from "../../store/actions"
import { usersAPI, teamsAPI } from "../../services/api"
import AlertModal from "../../components/Common/AlertModal"
import classnames from "classnames"

const UserList = (props) => {
    document.title = "Gestion de l'Équipe | Ticket Management"

    const [users, setUsers] = useState([])
    const [teams, setTeams] = useState([])
    const [activeTab, setActiveTab] = useState("all")
    const [modal, setModal] = useState(false)
    const [docModal, setDocModal] = useState(false)
    const [editingUser, setEditingUser] = useState(null)
    const [selectedUser, setSelectedUser] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        password: "",
        role: "collaborateur",
        telephone: "",
        team_ids: [],
    })

    const [docData, setDocData] = useState({
        nom: "",
        type: "cv",
        fichier: null,
    })

    const [alertConfig, setAlertConfig] = useState({
        isOpen: false,
        type: 'success',
        message: '',
        title: ''
    })

    const toggleAlert = () => setAlertConfig({ ...alertConfig, isOpen: !alertConfig.isOpen })

    const docTypes = [
        { key: 'demande_stage', label: 'Demande de stage' },
        { key: 'contrat', label: 'Contrat' },
        { key: 'attestation_travail', label: 'Attestation de travail' },
        { key: 'attestation_stage', label: 'Attestation de stage' },
        { key: 'cv', label: 'CV' },
        { key: 'contrat_confidentialite', label: 'Contrat de confidentialité' },
    ]

    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Utilisateurs", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Gestion de l'équipe", breadcrumbItems)
        fetchData()
    }, [])

    const fetchData = async () => {
        try {
            const [userRes, teamRes] = await Promise.all([
                usersAPI.getAll(),
                teamsAPI.getAll()
            ])
            setUsers(userRes.data)
            setTeams(teamRes.data)
        } catch (error) {
            console.error("Erreur lors du chargement des données", error)
        }
    }

    const toggleModal = () => {
        setModal(!modal)
        if (!modal) {
            setEditingUser(null)
            setError(null)
            setLoading(false)
            setFormData({
                name: "",
                email: "",
                password: "",
                role: "collaborateur",
                telephone: "",
                team_ids: [],
            })
        }
    }

    const toggleDocModal = (user = null) => {
        setSelectedUser(user)
        setDocModal(!docModal)
        setDocData({ nom: "", type: "cv", fichier: null })
    }

    const handleEdit = (user) => {
        setEditingUser(user)
        setFormData({
            name: user.name,
            email: user.email,
            password: "",
            role: user.role,
            telephone: user.telephone || "",
            team_ids: user.teams ? user.teams.map(t => t.id) : [],
        })
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")) {
            try {
                await usersAPI.delete(id)
                fetchData()
            } catch (error) {
                console.error("Erreur lors de la suppression", error)
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()

        // Prevent double submission
        if (loading) return

        console.log('🚀 [DEBUT] handleSubmit - Données du formulaire:', formData)
        console.log('🚀 Mode:', editingUser ? 'MODIFICATION' : 'CRÉATION')

        setLoading(true)
        setError(null)

        try {
            console.log('📡 [REQUÊTE] Envoi de la requête API...')

            let response
            if (editingUser) {
                console.log('📝 [UPDATE] Mise à jour utilisateur ID:', editingUser.id)
                response = await usersAPI.update(editingUser.id, formData)
            } else {
                console.log('➕ [CREATE] Création nouvel utilisateur')
                response = await usersAPI.create(formData)
            }

            console.log('✅ [SUCCÈS] Réponse reçue:', response)
            console.log('✅ [SUCCÈS] Données utilisateur:', response.data)

            toggleModal()
            setAlertConfig({
                isOpen: true,
                type: 'success',
                title: editingUser ? 'Utilisateur modifié' : 'Utilisateur créé',
                message: editingUser ? "L'utilisateur a été mis à jour avec succès." : "L'utilisateur a été créé avec succès."
            })

            console.log('🔄 [REFRESH] Rechargement des données...')
            fetchData()

        } catch (error) {
            console.error('❌ [ERREUR] Erreur lors de l\'enregistrement', error)
            console.error('❌ [ERREUR] Type:', error.name)
            console.error('❌ [ERREUR] Message:', error.message)
            console.error('❌ [ERREUR] Code:', error.code)
            console.error('❌ [ERREUR] Response:', error.response)
            console.error('❌ [ERREUR] Request:', error.request)
            console.error('❌ [ERREUR] Config:', error.config)

            // Display validation errors
            if (error.response?.data?.errors) {
                const errors = error.response.data.errors
                const errorMessages = Object.values(errors).flat().join(', ')
                console.error('❌ [ERREUR VALIDATION]:', errorMessages)
                setError(errorMessages)
            } else if (error.response?.data?.message) {
                console.error('❌ [ERREUR MESSAGE]:', error.response.data.message)
                setError(error.response.data.message)
            } else {
                console.error('❌ [ERREUR GÉNÉRIQUE]')
                setError("Une erreur est survenue lors de l'enregistrement")
            }

            setAlertConfig({
                isOpen: true,
                type: 'error',
                title: 'Erreur',
                message: error.response?.data?.message || error.response?.data?.errors ? "Des erreurs de validation sont survenues." : "Une erreur est survenue lors de l'enregistrement."
            })
        } finally {
            console.log('🏁 [FIN] handleSubmit - Loading:', false)
            setLoading(false)
        }
    }

    const handleDocSubmit = async (e) => {
        e.preventDefault()
        const data = new FormData()
        data.append('fichier', docData.fichier)
        data.append('nom', docData.nom || docTypes.find(t => t.key === docData.type).label)
        data.append('type', docData.type)

        try {
            await usersAPI.uploadDocument(selectedUser.id, data)
            toggleDocModal(selectedUser)
            fetchData()
        } catch (error) {
            console.error("Erreur upload", error)
        }
    }

    const filteredUsers = activeTab === "all" ? users : users.filter(u => u.role === activeTab)

    const data = {
        columns: [
            { label: "Nom", field: "name", sort: "asc" },
            { label: "Email", field: "email", sort: "asc" },
            { label: "Level", field: "level", sort: "asc" },
            { label: "Points", field: "points", sort: "asc" },
            { label: "Argent (DH)", field: "argent", sort: "asc" },
            { label: "Téléphone", field: "telephone", sort: "asc" },
            { label: "Équipe", field: "team", sort: "asc" },
            { label: "Documentation", field: "docs", sort: "disabled" },
            { label: "Actions", field: "actions", sort: "disabled" },
        ],
        rows: filteredUsers.map((u) => ({
            name: (
                <div className="d-flex align-items-center">
                    <div className="avatar-xs me-2">
                        <span className="avatar-title rounded-circle bg-soft-primary text-primary">
                            {(u.name || "?").charAt(0)}
                        </span>
                    </div>
                    <div>
                        <h5 className="font-size-14 mb-0">{u.name || "N/A"}</h5>
                        <small className="text-muted">{(u.role || "unknown").toUpperCase()}</small>
                    </div>
                </div>
            ),
            email: u.email,
            level: (
                <Badge color="info" className="font-size-12">
                    Lvl {u.level || 1}
                </Badge>
            ),
            points: (
                <Badge color="soft-warning" className="bg-soft-warning text-warning border font-size-12">
                    <i className="mdi mdi-star me-1"></i>
                    {u.points || 0}
                </Badge>
            ),
            argent: (
                <span className="fw-bold text-primary">
                    {(u.total_dh || 0).toLocaleString()} DH
                </span>
            ),
            telephone: u.telephone || "-",
            team: u.teams && u.teams.length > 0 ? (
                <div className="d-flex flex-wrap gap-1">
                    {u.teams.map(team => (
                        <Badge key={team.id} color="soft-primary" className="bg-soft-primary text-primary border">
                            {team.nom}
                        </Badge>
                    ))}
                </div>
            ) : "-",
            docs: (
                <div className="d-flex flex-wrap gap-1">
                    {docTypes.map(type => {
                        const hasDoc = u.documents?.some(d => d.type === type.key);
                        return (
                            <Badge
                                key={type.key}
                                color={hasDoc ? "success" : "light"}
                                className={hasDoc ? "" : "text-muted border"}
                                title={type.label}
                            >
                                {type.key === 'demande_stage' ? 'DS' :
                                    type.key === 'contrat' ? 'CT' :
                                        type.key === 'attestation_travail' ? 'AT' :
                                            type.key === 'attestation_stage' ? 'AS' :
                                                type.key === 'cv' ? 'CV' : 'CC'}
                            </Badge>
                        )
                    })}
                    <Button color="link" size="sm" className="p-0 ms-2" onClick={() => toggleDocModal(u)}>
                        <i className="mdi mdi-plus-circle text-primary"></i>
                    </Button>
                </div>
            ),
            actions: (
                <div className="d-flex gap-2">
                    <Button color="primary" size="sm" onClick={() => handleEdit(u)}>
                        <i className="mdi mdi-pencil"></i>
                    </Button>
                    <Button color="danger" size="sm" onClick={() => handleDelete(u.id)}>
                        <i className="mdi mdi-trash-can"></i>
                    </Button>
                </div>
            ),
        })),
    }

    return (
        <React.Fragment>
            <Row>
                <Col className="col-12">
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <CardTitle className="h4">Gestion de l'Équipe</CardTitle>
                                <Button color="success" onClick={toggleModal}>
                                    <i className="mdi mdi-plus me-1"></i> Nouvel Utilisateur
                                </Button>
                            </div>

                            <Nav tabs className="nav-tabs-custom mb-3">
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "all" })}
                                        onClick={() => setActiveTab("all")}
                                    >
                                        Tous
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "manager" })}
                                        onClick={() => setActiveTab("manager")}
                                    >
                                        Managers
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "collaborateur" })}
                                        onClick={() => setActiveTab("collaborateur")}
                                    >
                                        Collaborateurs
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={classnames({ active: activeTab === "client" })}
                                        onClick={() => setActiveTab("client")}
                                    >
                                        Clients
                                    </NavLink>
                                </NavItem>
                            </Nav>

                            <TabContent activeTab={activeTab}>
                                <TabPane tabId={activeTab}>
                                    <MDBDataTable
                                        noBottomColumns
                                        responsive
                                        striped
                                        bordered
                                        data={data}
                                        entriesLabel="Afficher"
                                        searchLabel="Rechercher"
                                        infoLabel={["Affichage de", "à", "sur", "entrées"]}
                                        paginationLabel={["Précédent", "Suivant"]}
                                        noRecordsFoundLabel="Aucun enregistrement trouvé"
                                    />
                                </TabPane>
                            </TabContent>
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>
                    {editingUser ? "Modifier l'Utilisateur" : "Nouvel Utilisateur"}
                </ModalHeader>
                <Form onSubmit={handleSubmit}>
                    <ModalBody>
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="name">Nom Complet</Label>
                                    <Input
                                        type="text"
                                        id="name"
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input
                                        type="email"
                                        id="email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="password">Mot de passe {editingUser && "(laisser vide pour ne pas changer)"}</Label>
                                    <Input
                                        type="password"
                                        id="password"
                                        value={formData.password}
                                        onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                        required={!editingUser}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="role">Rôle</Label>
                                    <Input
                                        type="select"
                                        id="role"
                                        value={formData.role}
                                        onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                                    >
                                        <option value="collaborateur">Collaborateur</option>
                                        <option value="manager">Manager</option>
                                        <option value="client">Client</option>
                                        <option value="admin">Administrateur</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="telephone">Téléphone</Label>
                                    <Input
                                        type="text"
                                        id="telephone"
                                        value={formData.telephone}
                                        onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label for="team_ids">Équipes</Label>
                                    <Select
                                        isMulti
                                        options={teams.map(t => ({ value: t.id, label: t.nom }))}
                                        value={teams.filter(t => formData.team_ids.includes(t.id)).map(t => ({ value: t.id, label: t.nom }))}
                                        onChange={(selectedOptions) => setFormData({ ...formData, team_ids: selectedOptions ? selectedOptions.map(o => o.value) : [] })}
                                        classNamePrefix="select2-selection"
                                        placeholder="Sélectionner des équipes..."
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={toggleModal} disabled={loading}>Annuler</Button>
                        <Button color="primary" type="submit" disabled={loading}>
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                    Enregistrement...
                                </>
                            ) : (
                                "Enregistrer"
                            )}
                        </Button>
                    </ModalFooter>
                </Form>
            </Modal>

            {/* Modal Documentation */}
            <Modal isOpen={docModal} toggle={() => toggleDocModal()} size="md">
                <ModalHeader toggle={() => toggleDocModal()}>Documentation - {selectedUser?.name}</ModalHeader>
                <ModalBody>
                    <div className="mb-4">
                        <h6>Documents existants</h6>
                        <div className="list-group list-group-flush">
                            {selectedUser?.documents?.map(doc => (
                                <div key={doc.id} className="list-group-item d-flex justify-content-between align-items-center px-0">
                                    <div>
                                        <Badge color="info" className="me-2">{doc.type.replace('_', ' ').toUpperCase()}</Badge>
                                        {doc.nom}
                                    </div>
                                    <a href={doc.url} target="_blank" rel="noreferrer" className="btn btn-sm btn-light">
                                        <i className="mdi mdi-download"></i>
                                    </a>
                                </div>
                            ))}
                            {(!selectedUser?.documents || selectedUser.documents.length === 0) && (
                                <p className="text-muted small">Aucun document chargé.</p>
                            )}
                        </div>
                    </div>

                    <Form onSubmit={handleDocSubmit}>
                        <h6>Ajouter un document</h6>
                        <FormGroup>
                            <Label>Type de document</Label>
                            <Input
                                type="select"
                                value={docData.type}
                                onChange={(e) => setDocData({ ...docData, type: e.target.value })}
                            >
                                {docTypes.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
                            </Input>
                        </FormGroup>
                        <FormGroup>
                            <Label>Libellé (optionnel)</Label>
                            <Input
                                type="text"
                                placeholder="Nom du fichier..."
                                value={docData.nom}
                                onChange={(e) => setDocData({ ...docData, nom: e.target.value })}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Fichier</Label>
                            <Input
                                type="file"
                                onChange={(e) => setDocData({ ...docData, fichier: e.target.files[0] })}
                                required
                            />
                        </FormGroup>
                        <Button color="primary" block type="submit">Uploader</Button>
                    </Form>
                </ModalBody>
            </Modal>

            <AlertModal
                isOpen={alertConfig.isOpen}
                toggle={toggleAlert}
                type={alertConfig.type}
                title={alertConfig.title}
                message={alertConfig.message}
            />
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(UserList)
